import React, { ReactNode, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";

import {
  MaterialReactTable,
  MRT_ColumnDef,
  MRT_TableInstance,
} from "material-react-table";



import { useMediaQuery } from "@mui/material";
import SegMainTable from "../../components/SEG-MAIN/segMain";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { setscrolling } from "../../redux/reducers/Segreducer";

interface RenderTopToolbarProps {
  table: MRT_TableInstance<any>; // Adjust the type according to your table's data type
}

type RenderTopToolbarFunction = (
  props: RenderTopToolbarProps
) => React.ReactNode;
interface RenderBottomToolbarProps {
  table: MRT_TableInstance<any>; // Adjust the type according to your table's data type
}

type RenderBottomToolbarFunction = (
  props: RenderBottomToolbarProps
) => React.ReactNode;

// Define the interface for table headers

interface TableHeaders {
  [key: string]: string; // Maps column keys to header names
}

// Define the interface for additional columns

interface AddNewCellColumn {
  accessorKey: string;

  header: string;

  Cell?: (props: { row: any; index: number }) => JSX.Element;
}

interface changeColInterface<T> {
  accessorKey: string;

  header: string;

  Cell?: (props: { row: any }) => JSX.Element;

  // other properties
}

type ChangedDataCellColumnFunction = (
  header: string,

  accessor: string
) => changeColInterface<any>;

// Define the props interface with optional properties

interface CommonDataTableProps {
  data: any[]; // Replace `any` with a more specific type if known
  overflowX?:string;
  tableHeaders: TableHeaders;
  enableRowStyling?: boolean;

  element?: ReactNode;

  actionButtons?: boolean; // Optional

  editButton?: boolean; // Optional

  deleteButton?: boolean; // Optional

  callback: (data: any, index: number) => void;

  viewButton?: boolean; // Optional

  inputCells?: boolean; // Optional

  disableFields?: boolean; // Optional

  inputTypeColumnCallback?: (
    value: string,

    columnKey: string,

    index: number
  ) => void;

  addNewCellColumns?: AddNewCellColumn[]; // Optional

  changeSelectedColumnDataDesign?: string[]; // Optional

  changedDataCellColumn?: ChangedDataCellColumnFunction |any; // Optional

  customActionButton?: (row: any) => JSX.Element; // Optional

  topToolbar?: RenderTopToolbarFunction;
  bottomToolBar?:RenderBottomToolbarFunction;

  muiTableRowProps?: string;

  colSizes?: any[];

  enableTopToolbar?: boolean;

  nextCallback?: (data?: any) => void;
  

  selectedIndex ?: number | null;

  tableCursor?: string;

  enableGlobalFilter?: boolean;

  pageSize?: number;

  totalPages?: number;

  totalDocuments?: number;

  showRowNumbers?: boolean;

  isLoading?: boolean;

  enableBottomToolbar?: boolean;

  NodataFound?: string;

  scrollable?: boolean;
  FetchCallbackFun?: any;
  enableRowEditing?:boolean;
  muiTableProps?:any;
  className?:string;
  hasMore?:boolean;
  maxHeight?:string;
  reactcodeString?:string;
  scrollToLeftUpdate?:(data:any) => void;
}



// interface PaginationState {
//   pageIndex: number;

//   pageSize: number;
// }

export const CommonDataTable: React.FC<CommonDataTableProps> = ({
  data,

  tableHeaders,


  actionButtons = false, // Default value

  callback,

  inputCells = false, // Default value

  disableFields = false, // Default value

  inputTypeColumnCallback = () => {}, // Default empty function

  changeSelectedColumnDataDesign = [], // Default empty array

  changedDataCellColumn,

  customActionButton,

  topToolbar,
  bottomToolBar,

  muiTableRowProps = "",

  colSizes = [],

  enableTopToolbar = false,

  enableGlobalFilter = false,

  selectedIndex ,

  tableCursor = "",

  pageSize = 15,

  totalPages,

  showRowNumbers = true,

  enableBottomToolbar = false,

  NodataFound = "No record found",

  FetchCallbackFun,
  enableRowEditing=false,
  muiTableProps="",
  className="",
  overflowX="auto",
  hasMore=false,
  maxHeight="86vh",
  reactcodeString="",
  scrollToLeftUpdate
}) => {
  const dataKeys = Object.keys(tableHeaders);
  // const[scrollToEnd,setScrollToEnd]=useState(null)
  // const scrollRef = useRef<HTMLDivElement | null>(null);

  // const isSmallScreen = useMediaQuery("(max-width:768px)");

  // const isExtraSmallScreen = useMediaQuery("(max-width:530px)");

  // const [pagination, setPagination] = useState<PaginationState>({
  //   pageIndex: 0,

  //   pageSize: pageSize,
  // });

  const [page, setPage] = useState(1);
const scrolling=useSelector((state:RootState)=>state.SegReducer.scrolling);
const ScrollhasMore=useSelector((state:RootState)=>state.SegReducer.hasMore)

  // Define table columns based on headers and other props

  let tableColumns: MRT_ColumnDef<any>[] = [];

  if (showRowNumbers) {
    tableColumns.push({
      header: "S/No.", // Column header

      id: "rowNumber", // Unique column ID

      size: 50, // Column width

      Cell: ({ row }) =>
        totalPages
          ? row.index + 1 + (page > 1 ? pageSize * (page - 1) : 0)
          : row.index + 1, // Display row number
    });
  }

  tableColumns.push(
    ...dataKeys.map((e, index) => {
      if (changeSelectedColumnDataDesign.includes(e) && changedDataCellColumn) {
        return changedDataCellColumn(tableHeaders[e], e);
      }

      const columnDef: MRT_ColumnDef<any> = {
        accessorKey: e,

        header: tableHeaders[e],

        size: colSizes.length ? colSizes[index] : 50,

        Cell: ({ row }) => (row.original[e] ? row.original[e] : "-"),

        // headerProps: {
        //   sx: {
        //     padding: '8px',
        //     border: '0.5px solid #5C5C5C',
        //     textAlign: 'center',
        //     alignItems: 'center',
        //     backgroundColor: '#a6a6a6',
        //     outline: 'none',
        //     verticalAlign: 'middle',
        //   },
        // },
      };

      if (inputCells) {
        columnDef.Cell = ({ row }) => (
          <input
            type={
              typeof row.original[e] === "string"
                ? "text"
                : typeof row.original[e] === "number"
                ? "number"
                : "text"
            }
            className="form-control"
            onChange={({ target }) =>
              inputTypeColumnCallback(target.value, e, row.index)
            }
            disabled={disableFields}
            value={row.original[e]}
            placeholder={tableHeaders[e]}
          />
        );
      }

      return columnDef;
    })
  );

  if (customActionButton && actionButtons) {
    tableColumns.push({
      id: "actions",

      header: "Action",

      Cell: ({ row }) => (
        <div className="hstack gap-2 fs-1">{customActionButton(row)}</div>
      ),
      enableEditing: false,
    });
  }
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const element = scrollRef.current;
  //     if (!element) return;

  //     // Safely access properties after null check
  //     const scrollHeight = element.scrollHeight;
  //     const scrollTop = element.scrollTop;
  //     const clientHeight = element.clientHeight;

  //     // Buffer of 50px before reaching bottom
  //     // const isNearBottom = scrollHeight - scrollTop - clientHeight < 5;
  //     const isAtBottom = scrollHeight - scrollTop === clientHeight;
  //     if (isAtBottom) {
  //       FetchCallbackFun()
  //     }
  //   };

  //   const element = scrollRef.current;
  //   if (element) {
  //     element.addEventListener('scroll', handleScroll);
      
  //     return () => {
  //       element.removeEventListener('scroll', handleScroll);
  //     };
  //   }
  // }, []);
  // const getTableBodyRowProps = (row: any) => {
  //   if (!enableRowStyling) {
  //     return {
  //       className:muiTableRowProps,
  //       sx:{
  //         backgroundColor: row.index === selectedIndex ? 'white' : 'white',
  //         '&:hover': {
  //           backgroundColor: row.index === selectedIndex ? 'white' : 'white',
  //         },
  //       }
  //     };  // Return empty object if styling is disabled
  //   }
    
  //   return {
  //     className: muiTableRowProps,
  //     sx: {
  //       height: "20px",
  //       backgroundColor: row.index === selectedIndex ? '#d9d9d9' : 'white',
  //       '&:hover': {
  //         backgroundColor: row.index === selectedIndex ? 'yellow' : 'yellow',
  //       },
  //       cursor: tableCursor,
  //       alignItems: "center",
  //       justifyContent: "center",
  //       textAlign: "center",
  //     },
  //     onClick: () => callback(row.original, row.index),
  //   };
  // };
  const scrollRef = useRef<HTMLDivElement | null>(null);
 
  const handleScroll = useCallback(() => {
    
    if (scrollRef.current) {
    
      const element = scrollRef.current;
      // Check if at the far left (scrollLeft is 0)
      // const isAtLeft = element.scrollLeft === 0;
      if(scrollToLeftUpdate)
        scrollToLeftUpdate(element.scrollLeft)
      // Check if at the far right (scrollLeft is at max)
      // const isAtRight = element.scrollLeft + element.clientWidth === element.scrollWidth;
      
      // console.log(element.scrollLeft,"at left ", isAtRight, " at right")

      const isAtBottom = (
        element.scrollHeight - element.scrollTop - element.clientHeight
      ) <= 1;
 
      if (isAtBottom && hasMore) {
        if(FetchCallbackFun) FetchCallbackFun()
        // Add your logic here for when bottom is reached
      }
    }
  }, [hasMore]);

  // const [data, setData] = useState([
  //   { id: 1, name: "John Doe", age: 25 },
  //   { id: 2, name: "Jane Smith", age: 30 },
  // ]);
  // useEffect(() => {
  //   const newRow = { id: 3, name: "Manually Added Row", age: 35 }; // Define your manual row here
  //   setData((prevData) => [...prevData, newRow]); // Append it to the existing data
  // }, []);

  // if(scrollRef.current && data.length > 0){
    // console.log(scrollRef.current.innerHTML)
    // scrollRef.current.innerHTML += '<div class="absolute bottom-0">hihihih</div>';
  // }
  // console.log(tableContainer)
  let tableTag: HTMLTableElement | null = null;

  const tableElement = document.getElementById("total-table");
  if (tableElement) {
    tableTag = tableElement.querySelector("table");
  }


// Get the parent element by ID
// const totalTable = document.getElementById("total-table");

// Convert the string to a DOM element and append it


useEffect(() => {
  if (tableTag && reactcodeString) {
    const existingTfoot = tableTag.querySelector('tfoot'); // Check if there is an existing <tfoot> element
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = reactcodeString.trim(); // Parse the reactcodeString

    const newTfoot = tempDiv.querySelector('tfoot'); // Extract the <tfoot> element from the parsed HTML

    if (newTfoot) {
      if (existingTfoot) {
        // If there is an existing <tfoot>, replace it with the new one
        tableTag.replaceChild(newTfoot, existingTfoot);
      } else {
        // If there is no existing <tfoot>, append the new one
        tableTag.appendChild(newTfoot);
      }
    }
  }
}, [tableTag, reactcodeString]);

const scrolltoTop=()=>{
  if (scrollRef.current) {
    scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
 
    console.log("Scrolled container to top", scrollRef.current);
  }
}
useEffect(()=>{
  if(scrolling && ScrollhasMore ){
    scrolltoTop()
  }
},[scrolling , ScrollhasMore])

  return (
    <div className={`${className} `} >
      <MaterialReactTable
            muiTableContainerProps={{
              ref: scrollRef,
              onScroll: handleScroll,
              id:"total-table",
              sx: {
                width: 'w-full',
                position:'relative',
                maxHeight: maxHeight,
                overflowY: 'auto',
                overflowX: overflowX
              }
            }}
       
      // FetchCallbackFun={FetchCallbackFun}
      enablePagination={false}
        columns={tableColumns}
        data={data}
        enableEditing={enableRowEditing}
        editDisplayMode={"table"}
        enableRowNumbers={false}
        enableSorting={false}
        enableFullScreenToggle={false}
        enableDensityToggle={false}
        enableHiding={false}
        enableColumnFilters={false}
        enableColumnActions={false}
        enableGlobalFilter={enableGlobalFilter}
        renderTopToolbar={topToolbar}
        renderBottomToolbar={bottomToolBar}
        enableTopToolbar={enableTopToolbar}
        enableStickyHeader={true}
        // tableProps={{
        //   id: 'my-custom-table-id', // Set the ID here
        // }}
        // muiTableBodyRowProps={({ row }) => getTableBodyRowProps(row)}

        muiTableProps={muiTableProps}
        // muiTableProps={{
        //   sx: {
        //     zIndex: 0,
        //   },
        // }}
        muiTableHeadProps={{
          sx: {
            '& .MuiTableRow-head': {
              '& .MuiTableCell-head': {
                padding: "8px",
                border: ".5px solid #5C5C5C",
                textAlign: "center",
                alignItems:"center",
                backgroundColor: '#a6a6a6',
                outline: "none",
                verticalAlign: "middle",
              },
              '& .Mui-TableHeadCell-Content-Wrapper': {
                display: 'block',
                whiteSpace: 'pre-line', // Ensure line breaks work
              },
            },
          },
        }}
        muiTableHeadCellProps={{
          sx: {
            textAlign: 'center',
            justifyContent: 'center',
            fontFamily:"poppins",
            '& .Mui-TableHeadCell-Content': {
              justifyContent: 'center',
              textAlign: 'center',
              // width: '100%',
            },
            '& .Mui-TableHeadCell-Content-Labels': {
              justifyContent: 'center',
              textAlign: 'center',
            },
            '& .Mui-TableHeadCell-Content-Wrapper': {
              justifyContent: 'center',
              textAlign: 'center',
            },
          },
        }}
        // muiTableHeadCellProps={{
        //   sx: {
        //     paddingLeft: "8px",

        //     border: ".5px solid #707070",

        //     fontSize: "13px",

        //     textAlign: "center",

        //     backgroundColor: "#A0A0A0"
        //   },
        // }}
        muiTableBodyCellProps={{
          sx: {
            padding: "8px",
            border: ".5px solid #5C5C5C",

            alignItems: "center",

            justifyContent: "center",

            textAlign: "center",
          },
        }}
        muiTableBodyRowProps={({ row }) => {
          return {
            className: muiTableRowProps,

            sx: {
              height: "20px",
              
              backgroundColor: row.index === selectedIndex ? '#d9d9d9' : 'white',
              '&:hover': {
                backgroundColor: row.index === selectedIndex ? '#808080' : '#D3D3D3',
              },
            

              cursor: tableCursor,

              alignItems: "center",

              justifyContent: "center",

              textAlign: "center",
            },
            

            onClick: () => callback(row.original, row.index),
          };
        }}
        muiTopToolbarProps={{
          sx: {
            zIndex: 0,
          },
        }}
        // enableBottomToolbar={true}
        muiTableBodyProps={{
          sx: {
            '& .MuiTableRow-root': {
              '& .MuiTableCell-body': {
                border: '0.5px solid #5C5C5C', // Consistent border styling
              },
            },
          },
        }}
        enableBottomToolbar={enableBottomToolbar}
        renderEmptyRowsFallback={({ table }) => (
          <div className=" text-gray-400 m-3 text-[14px] flex items-center justify-center">
            {NodataFound}{" "}
          </div>
            )}
        // muiTableFooterProps={{
        //   sx: {
        //     position: 'sticky', // Sticky footer
        //     bottom: 0, // Stick to the bottom
        //     zIndex: 1, // Ensure it stays above table body
        //     backgroundColor: '#a6a6a6', // Style to match header
        //     '& .MuiTableCell-footer': {
        //       padding: '8px',
        //       border: '0.5px solid #5C5C5C',
        //       textAlign: 'center',
        //       fontWeight: 'bold', // Bold text to mimic header
        //     },
        //   },
        // }}
        // renderBottomToolbar={() => (
        //   <div
        //     style={{
        //       display: 'flex',
        //       justifyContent: 'space-around', // Adjusts column header alignment
        //       backgroundColor: '#a6a6a6', // Match header background color
        //       padding: '8px',
        //       borderTop: '0.5px solid #5C5C5C', // Border above footer
        //       width:"100%"
        //     }}
        //   >
        //     {tableColumns.map((column, index) => (
        //       <div key={index} style={{ textAlign: 'center', fontWeight: 'bold', width:"400px" }}>
        //         {column.header}
        //       </div>
        //     ))}
        //   </div>
        // )}
        // muiBottomToolbarProps={{
        //   sx: {
        //     '& .MuiToolbar-root': {
        //       padding: '8px',
        //       borderTop: '0.5px solid #5C5C5C',
        //       backgroundColor: '#a6a6a6',
        //       display: 'flex',
        //       justifyContent: 'center',
        //       alignItems: 'center',
        //       outline: 'none',
        //     },
        //     '& .MuiTablePagination-root': {
        //       justifyContent: 'center',
        //       '& .MuiTablePagination-toolbar': {
        //         padding: '0 16px',
        //       },
        //       '& .MuiTablePagination-displayedRows, & .MuiTablePagination-selectLabel': {
        //         fontFamily: 'Poppins',
        //         color: '#000',
        //       },
        //     },
        //   },
        // }}
        // state={{
        //   pagination: {
        //     pageIndex: pagination.pageIndex,

        //     pageSize: pagination.pageSize,
        //   },
        // }}
        // initialState={{
        //   pagination: {
        //     pageIndex: pagination.pageIndex,

        //     pageSize: pagination.pageSize,
        //   },
        // }}
        // renderBottomToolbar={({ table }) => (
        //     <div className="flex ">
        //       <table className="border-collapse border border-neutral-200 w-full ">
        //         <tbody>
        //           <tr className="bg-white text-[13px]  text-center items-center  ">
        //             <td
        //               colSpan={2}
        //               className="font-semibold border-2 border-solid border-gray-200 text-center
        //           h-6
        //           "
        //             >
        //               Total
        //             </td>
        //             <td
        //               className="font-semibold border-2 border-solid border-gray-200 text-center
        //           h-6 
        //           "
        //             >
        //               Comparable Title
        //             </td>
        //             <td
                      
        //               className="font-semibold border-2 border-solid border-gray-200 text-center
        //           h-6 w-[120px]
        //           "
        //             >
        //               Comparable Title
        //             </td>
        //             <td
                      
        //               className="font-semibold border-2 border-solid border-gray-200 text-center
        //           h-6 w-[120px]
        //           "
        //             >
        //               Comparable Title
        //             </td>
        //             <td
                      
        //               className="font-semibold border-2 border-solid border-gray-200 text-center
        //           h-6 w-[120px]
        //           "
        //             >
        //               Comparable Title
        //             </td>
        //             <td
                      
        //               className="font-semibold border-2 border-solid border-gray-200 text-center
        //           h-6 w-[120px]
        //           "
        //             >
        //               Comparable Title
        //             </td>
        //             <td
                      
        //               className="font-semibold border-2 border-solid border-gray-200 text-center
        //           h-6 w-[120px]
        //           "
        //             >
        //               Comparable Title
        //             </td>
        //             <td
                      
        //               className="font-semibold border-2 border-solid border-gray-200 text-center
        //           h-6 w-[120px]
        //           "
        //             >
        //               Comparable Title
        //             </td>
        //             <td
                      
        //               className="font-semibold border-2 border-solid border-gray-200 text-center
        //           h-6 w-[120px]
        //           "
        //             >
        //               Comparable Title
        //             </td>
        //             <td
                      
        //               className="font-semibold border-2 border-solid border-gray-200 text-center
        //           h-6 w-[120px]
        //           "
        //             >
        //               Comparable Title
        //             </td>
        //             <td
                      
        //               className="font-semibold border-2 border-solid border-gray-200 text-center
        //           h-6 w-[120px]
        //           "
        //             >
        //               Comparable Title
        //             </td>
        //             <td
                      
        //               className="font-semibold border-2 border-solid border-gray-200 text-center
        //           h-6 w-[120px]
        //           "
        //             >
        //               Comparable Title
        //             </td>
        //             <td
                      
        //               className="font-semibold border-2 border-solid border-gray-200 text-center
        //           h-6 w-[120px]
        //           "
        //             >
        //               Comparable Title
        //             </td>
        //           </tr>
        //         </tbody>
        //       </table>
        //     </div>
        // )
          // bottomToolBar
          // ({ table }) => {
          // return (
          //   <div
          //     className={` bg-white flex ${
          //       scrollable ? "justify-start ml-5" : "justify-end "
          //     } gap-4 items-center text-[14px]`}
          //   >
          //     {/* <p
          //       style={{
          //         fontSize: isExtraSmallScreen ? "0.65rem" : "0.87rem",

          //         margin: "0",
          //       }}
          //     >
          //       {`${
          //       totalDocuments
          //         ? pageSize * page > totalDocuments
          //           ? totalDocuments
          //           : pageSize * page
          //         : page * pageSize > data?.length
          //         ? data?.length
          //         : data?.length <= 0
          //         ? 0
          //         : page * pageSize
          //     } / ${totalDocuments ? totalDocuments : data?.length}`}</p> */}

          //     {!scrollable && (
          //       <Stack spacing={2} direction="row">
          //         <Pagination
          //           renderItem={(item) => {
          //             let tooltipTitle = "";

          //             switch (item.type) {
          //               case "first":
          //                 tooltipTitle = "First Page";

          //                 break;

          //               case "previous":
          //                 tooltipTitle = "Previous Page";

          //                 break;

          //               case "next":
          //                 tooltipTitle = "Next Page";

          //                 break;

          //               case "last":
          //                 tooltipTitle = "Last Page";

          //                 break;

          //               default:
          //                 tooltipTitle = "";
          //             }

          //             return (
          //               <Tooltip
          //                 title={tooltipTitle}
          //                 PopperProps={{
          //                   modifiers: [
          //                     {
          //                       name: "offset",

          //                       options: {
          //                         offset: [0, -15],
          //                       },
          //                     },
          //                   ],
          //                 }}
          //               >
          //                 <PaginationItem
          //                   {...item}
          //                   sx={{
          //                     minWidth: isExtraSmallScreen ? "18px" : "30px",

          //                     height: isExtraSmallScreen ? "28px" : "32px",

          //                     margin: isExtraSmallScreen ? "1px" : "0 4px",

          //                     padding: "0",

          //                     fontSize: isExtraSmallScreen
          //                       ? "11px"
          //                       : "0.875rem",
          //                   }}
          //                 />
          //               </Tooltip>
          //             );
          //           }}
          //           siblingCount={
          //             isExtraSmallScreen ? 0 : isSmallScreen ? 1 : 1
          //           }
          //           boundaryCount={
          //             isExtraSmallScreen ? 1 : isSmallScreen ? 1 : 1
          //           }
          //           size={isSmallScreen ? "small" : "medium"}
          //           // onChange={(event, value) => {
          //           //   setPage(value);

          //           //   if (!totalPages)
          //           //     setPagination((old) => ({
          //           //       pageIndex: value - 1,

          //           //       pageSize: old.pageSize,
          //           //     }));

          //           //   nextCallback && nextCallback(value);
          //           // }}
          //           count={totalPages ? totalPages : table.getPageCount()}
          //           showFirstButton
          //           showLastButton
          //           page={page}
          //           sx={{
          //             display: "flex-row",

          //             justifyContent: "center",

          //             alignItems: "center",
          //           }}
          //         />
          //       </Stack>
          //     )}
          //   </div>
          // );}
      // }
        // renderEmptyRowsFallback={({ table }) => (
        //   <div className=" text-gray-400 m-3 text-[14px] flex items-center justify-center">
        //     {NodataFound}{" "}
        //   </div>
        // )}
      //   renderBottomToolbar={({ table }) => (
      //       <div className="flex ">
      //         <table className="border-collapse border border-neutral-200 w-full ">
      //           <tbody>
      //             <tr className="bg-white text-[13px]  text-center items-center  ">
      //               <td
      //                 colSpan={2}
      //                 className="font-semibold border-2 border-solid border-gray-200 text-center
      //             h-6
      //             "
      //               >
      //                 Total
      //               </td>
      //               <td
      //                 className="font-semibold border-2 border-solid border-gray-200 text-center
      //             h-6 
      //             "
      //               >
      //                 Comparable Title
      //               </td>
      //               <td
                      
      //                 className="font-semibold border-2 border-solid border-gray-200 text-center
      //             h-6 w-[120px]
      //             "
      //               >
      //                 Comparable Title
      //               </td>
      //               <td
                      
      //                 className="font-semibold border-2 border-solid border-gray-200 text-center
      //             h-6 w-[120px]
      //             "
      //               >
      //                 Comparable Title
      //               </td>
      //               <td
                      
      //                 className="font-semibold border-2 border-solid border-gray-200 text-center
      //             h-6 w-[120px]
      //             "
      //               >
      //                 Comparable Title
      //               </td>
      //               <td
                      
      //                 className="font-semibold border-2 border-solid border-gray-200 text-center
      //             h-6 w-[120px]
      //             "
      //               >
      //                 Comparable Title
      //               </td>
      //               <td
                      
      //                 className="font-semibold border-2 border-solid border-gray-200 text-center
      //             h-6 w-[120px]
      //             "
      //               >
      //                 Comparable Title
      //               </td>
      //               <td
                      
      //                 className="font-semibold border-2 border-solid border-gray-200 text-center
      //             h-6 w-[120px]
      //             "
      //               >
      //                 Comparable Title
      //               </td>
      //               <td
                      
      //                 className="font-semibold border-2 border-solid border-gray-200 text-center
      //             h-6 w-[120px]
      //             "
      //               >
      //                 Comparable Title
      //               </td>
      //               <td
                      
      //                 className="font-semibold border-2 border-solid border-gray-200 text-center
      //             h-6 w-[120px]
      //             "
      //               >
      //                 Comparable Title
      //               </td>
      //               <td
                      
      //                 className="font-semibold border-2 border-solid border-gray-200 text-center
      //             h-6 w-[120px]
      //             "
      //               >
      //                 Comparable Title
      //               </td>
      //               <td
                      
      //                 className="font-semibold border-2 border-solid border-gray-200 text-center
      //             h-6 w-[120px]
      //             "
      //               >
      //                 Comparable Title
      //               </td>
      //               <td
                      
      //                 className="font-semibold border-2 border-solid border-gray-200 text-center
      //             h-6 w-[120px]
      //             "
      //               >
      //                 Comparable Title
      //               </td>
      //             </tr>
      //           </tbody>
      //         </table>
      //       </div>
      //   )
      // }
      />
    </div>
  );
};
